import { Component } from '@angular/core';
import { SignTitleAdjustment } from 'src/app/model/sign/title/sign-title-adjustment';
import { EditAssociationComponent } from '../edit-association.component';
import { SignTitleAdjustmentControllerRequestService } from '../../../../../services/api/sign-associations/implementations/sign-title-adjustment-controller-request.service';
import { NgForage } from 'ngforage';
import { SignTitleAdjustmentFactory } from 'src/app/services/stock/title/factory/sign-title-adjustment-factory';

@Component({
  selector: 'sign-title-adjustment-edit',
  templateUrl: '../edit-association.component.html',
  styleUrls: ['../edit-association.component.scss']
})
export class SignTitleAdjustmentEditComponent extends EditAssociationComponent<
  SignTitleAdjustment
> {
  constructor(
    protected ngForage: NgForage,
    private signTitleAdjustmentFactory: SignTitleAdjustmentFactory,
    private signTitleAdjustmentControllerRequestService: SignTitleAdjustmentControllerRequestService
  ) {
    super(ngForage);
  }

  protected initializeAssociationType(): void {
    this.associationType = 'SignTitleAdjustment';
  }

  protected initializeAssocObject(): void {
    if (this.assocObject == null) {
      this.assocObject = this.signTitleAdjustmentFactory.createSignTitleAdjustment();
      this.loading = false;
    } else {
      this.signTitleAdjustmentControllerRequestService
        .getById(this.assocObject.id)
        .then((signTitleAdjustment: SignTitleAdjustment) => {
          this.assocObject = signTitleAdjustment;
          this.loading = false;
        });
    }
  }

  protected getSavePromise(): Promise<SignTitleAdjustment> {
    return this.assocObject.id == null
      ? this.signTitleAdjustmentControllerRequestService.create(
          this.assocObject,
          this.signId
        )
      : this.signTitleAdjustmentControllerRequestService.update(
          this.assocObject,
          this.signId
        );
  }
}
